import { useState } from "react"
import { useEffect } from "react"
import { sbaAxios } from "../utils/sbaAxios";
import { getPortfolioSummary } from "../../config/apiConfig";
import moment from "moment";
import { AgGridReact } from "ag-grid-react";
import { CurrencyFormat } from "../utils/currencyFormattter";

export const PortfolioSummaryWidget = ({ selectedFamily }) => {
    const [gridData, setGridData] = useState([]);
    const [isAdvised, setIsAdvised] = useState(false);

    useEffect(() => {
        if (selectedFamily?.FamilyId) {
            getSummaryData(selectedFamily.FamilyId, isAdvised ? true : false);
        }
    }, [selectedFamily, isAdvised]);
    const getSummaryData = (id, Advised) => {
        sbaAxios({ url: `${getPortfolioSummary}?familyId=${id}&isAdvised=${Advised}` }).then(res => {
            setGridData(res)
        }
        ).catch(er => {
            setGridData([])
        })

    }
    const colDef = [
        { headerName: "Portfolio Name", field: "PortfolioName" },
        {
            headerName: "Market Value",
            field: "MarketValue",
            headerClass: "text-end",
            cellClass: "text-end",
            valueFormatter: (params) => {
                return CurrencyFormat(params.value, 2);
            },
            // cellStyle: { textAlign: "right" },
        },
        {
            headerName: "Inception Date",
            field: "InceptionDate",
            valueFormatter: (params) => {
                return moment(params?.value).format("MM/DD/YYYY");
            },
        },
        {
            headerName: "Status", field: "Status",
            cellRenderer: (params) => (params.value ? <>Active</> : <>Inactive</>)
        }
    ];

    const defColDef = { flex: 1, resizable:true };
    return <>
        <div className="k-tilelayout-item-header k-card-header">
            <div className="header-container">
                <b>Portfolio Summary</b>
                <div className="button-container"><button
                    key={0}
                    className={isAdvised ? "selected-non-gappable-button p-2" : "non-gappable-button p-2"}
                    onClick={() => setIsAdvised(true)}>
                    {"Advised"}
                </button>
                    <button
                        key={1}
                        className={!isAdvised ? "selected-non-gappable-button p-2" : "non-gappable-button p-2"}
                        onClick={() => setIsAdvised(false)}>
                        {"Total"}
                    </button>
                </div></div>
        </div>
        <div className="portfolio-summary-widget h-75">
            <div className="ag-theme-alpine h-100">
                <AgGridReact
                    rowData={gridData}
                    columnDefs={colDef}
                    defaultColDef={defColDef}
                ></AgGridReact>
            </div>
        </div>
    </>
}
